import { ReactNode } from 'react';
import { IconType } from 'react-icons/lib';
import { useField } from './useField';

export type InfoParams = {
  icon?: IconType;
  title: string;
  color?: 'default' | 'primary' | 'secondary' | 'success' | 'warning' | 'danger';
  description?: string;
  className?: string;
  endContent?: ReactNode;
};

export const useInfo = <T>() => {
  const info = useField<InfoParams | undefined>(undefined);

  const setTimeoutInfo = (infoMessage: InfoParams | undefined, duration?: number | undefined) => {
    info.setValue(infoMessage);
    info.schedule(() => info.setValue(undefined), duration || 6000);
  };

  return { info, setTimeoutInfo };
};
